<div class="text_black border_wrapper h-100 powertrain_wrapper summaryBox">
  <div
    class="p-4 d-flex align-items-center justify-content-between text-black h_20"
    style="border-top-left-radius: 6px; border-top-right-radius: 6px"
  >
    <h4 class="font-weight-bolder powertrain_headers">
      <span>Operational KPIs (24 Hour)</span>
      <span
        style="cursor: pointer"
        class="material-icons info"
        ngbPopover="
        The powertrain runtime is calculated as the difference between total hours in a day and total time lapsed in each stoppage during the day. The powertrain utilization is calculated as the percentage of runtime.
      "
        popoverClass="custom_popover"
        triggers="mouseenter:mouseleave"
        >info</span
      >
    </h4>
  </div>
  <div class="d-flex h_80" style="justify-content: space-around">
    <div class="mt-2 ml-4 flex flex_50 gap_10">
      <div class="column_response_text_left w-100 h_20">Number of Stops</div>
      <div class="column_response_text_left w-100 h_20">Run Time</div>
      <div class="column_response_text_left w-100 h_20">Utilization</div>
    </div>
    <div
      class="mt-2 mr-4 flex flex_50 gap_10"
      *ngIf="!machine_utilization_status_loader"
    >
      <div class="column_response_text_right h_20 text-center w-100">
        {{ machine_utilization.no_of_stops }}
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        {{ machine_utilization.avg_run }}
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        {{ machine_utilization.device_utilization }}%
      </div>
    </div>
    <div
      class="mt-2 mr-4 flex flex_50 gap_10"
      *ngIf="machine_utilization_status_loader"
      style="gap: 16px"
    >
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
    </div>
  </div>
</div>
